<template>
    <CSection v-if="policy.status > 0">
        <div class="pay-company-detail" v-if="policy.payCompanyDetailDTO.isCompanyPay == 1">
            <p>本保险合同保费由投保人{{ policy.applicantName }}企业账户支付</p>
        </div>
        <div class="pay-company-detail" v-if="policy.payCompanyDetailDTO.isCompanyPay == 0">
            <p v-if="policy.payCompanyDetailDTO.isCompanyPay == 0">本保险合同保费非投保人企业账户支付：</p>
            <v-flex class="form-item form-item-right">
                <label>付款人姓名</label>
                <p>{{ policy.payCompanyDetailDTO.payName }}</p>
            </v-flex>
            <v-flex class="form-item form-item-right">
                <label>账号</label>
                <p>{{ policy.payCompanyDetailDTO.payAccount }}</p>
            </v-flex>
            <v-flex class="form-item form-item-right">
                <label>待付款原因</label>
                <p>{{ policy.payCompanyDetailDTO.payAgentReason }}</p>
            </v-flex>
            <v-flex class="form-item form-item-right">
                <label style="margin-top: -10px">付款人与投保企业关系</label>
                <p>{{ policy.payCompanyDetailDTO.payRelation }}</p>
            </v-flex>
        </div>
    </CSection>
</template>

<script>
    export default {
        props:{
            policy: {
                type: Object,
                default: {}
            }
        },
        data(){
            return {
                solo: false,
            }
        }
    }
</script>

<style lang="scss">

    .form-item-right {
        label{
            width: 81px;
            margin-top: 0;
            text-align: right;
            font-size: 12px;
        }
        p{
            font-size: 12px;
        }
    }


</style>
